export const helpCenterUrl = "";
export const roadmapUrl = "https://roadmap.epanetjs.com";
export const landingPageUrl = "https://epanetjs.com";
export const quickStartTutorialUrl =
  "https://oasis-thursday-e5c.notion.site/Getting-Started-with-QUVUR-236a964f398780a0a6ffe3f4a72c802c";
export const newsletterUrl = "";
export const projectionConverterUrl =
  "https://utils.epanetjs.com/projection-converter";
export const studentAccountActiviationHelpUrl =
  "https://help.epanetjs.com/Free-educational-licenses-for-epanet-js-1cee18c9f0f68090aa35cd3336577ac3";

export const supportEmail = "numanovikrom454@gmail.com";
export const signUpUrl = process.env.NEXT_PUBLIC_SIGN_UP_URL as string;
export const pingUrl = process.env.NEXT_PUBLIC_PING_URL || "/ping.txt";
export const modelBuilderUrl =
  process.env.NEXT_PUBLIC_MODEL_BUILDER_URL ||
  "https://utils.epanetjs.com/model-builder?embedded=true";
export const customerPointsImportVideoUrl = "";
export const customerPointsImportGuide = "";
export const teamsPlanRequestFormUrl = "";
